import { ScheduledFarmItemTypes } from '@ourbranch/lookups';

export const MACHINERY_CATEGORIES = [
  ScheduledFarmItemTypes.COMBINES,
  ScheduledFarmItemTypes.CUSTOM_FARM_MACHINERY,
  ScheduledFarmItemTypes.DESCRIBED_MACHINERY,
  ScheduledFarmItemTypes.IRRIGATION_EQUIPMENT,
  ScheduledFarmItemTypes.MACHINERY_NOT_DESCRIBED,
  ScheduledFarmItemTypes.RENTED_OR_BORROWED_EQUIPMENT
];

export const OPEN_PERILS_CATEGORIES = [
  ScheduledFarmItemTypes.COMBINES,
  ScheduledFarmItemTypes.DESCRIBED_MACHINERY,
  ScheduledFarmItemTypes.IRRIGATION_EQUIPMENT
];

export const RCC_CATEGORIES = [
  ScheduledFarmItemTypes.COMBINES,
  ScheduledFarmItemTypes.DESCRIBED_MACHINERY,
  ScheduledFarmItemTypes.IRRIGATION_EQUIPMENT
];
